/**
 * Plano · Barrios · Distritos.
 *
 * A segmented control rather than a dropdown, unlike everything else in the bar:
 * this is the mode the whole city view is in, not a filter over it. Which one is
 * active has to be readable without opening anything, and switching is frequent
 * enough that a second click to reach it would be felt.
 *
 * A view whose boundaries are missing is offered but disabled, with the reason
 * on the control. Hiding it would be tidier and worse — the reader would be left
 * wondering whether the city has barrios at all, rather than knowing the data is
 * not in this deployment.
 */

import type { Vista } from "./lib/vista";
import { VISTAS, VISTA_HINTS, VISTA_LABELS } from "./lib/vista";

interface Props {
  vista: Vista;
  onChange: (next: Vista) => void;
  /** Views whose boundaries this deployment does not have. */
  unavailable?: readonly Vista[];
}

export function ViewSwitch({ vista, onChange, unavailable = [] }: Props) {
  return (
    // A radiogroup, not a toolbar: exactly one is always chosen, and that is
    // what tells a screen reader the three are alternatives to each other.
    <div className="view-switch" role="radiogroup" aria-label="Vista del mapa">
      {VISTAS.map((v) => {
        const off = unavailable.includes(v);
        return (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={vista === v}
            className={vista === v ? "view-btn active" : "view-btn"}
            disabled={off}
            title={off
              ? `${VISTA_HINTS[v]} — no disponible: faltan los límites en este despliegue`
              : VISTA_HINTS[v]}
            onClick={() => onChange(v)}
          >
            {VISTA_LABELS[v]}
          </button>
        );
      })}
    </div>
  );
}
